export { default as subCommunityOperations } from './operations';
export { default as subCommunitySelectors } from './selectors';
import reducer from './reducers';

export default reducer;
